<template>
  <div class="walletconnect">
    <box-loader ref="loader" :title="loaderTitle" :icon="loaderIcon" :description="loaderDescription"
      :buttonText="loaderButtonText" @hide="cancelPay()" />
    <div v-if="!hash">
      <div class="walletconnect__connection_container" v-if="!isConnected">
        <div class="walletconnect__title">Connect with external wallets</div>
        <div class="walletconnect__list">
          <button class="walletconnect__buttons" v-for="c in connectors" :key="c.id" @click="handleConnect(c)">
            <img class="walletconnect__wallet_icon" :src="getIcon(c.id)" alt="" />
            <div class="d-flex flex-column ml-2">
              <div class="walletconnect__wallet_name">{{ c.name }}</div>
              <div v-if="c.id === walletConnect" class="walletconnect__wallet_name_sub">
                Pay faster now and in the future
              </div>
              <img v-if="c.id === walletConnect" class="mt-2" src="@/assets/img/wallets.svg" alt="" />
            </div>
          </button>
          <div class="text-center">
            — — or — —
          </div>
          <button key="custom" name="custom_button" class="walletconnect__buttons"
            @click="$emit('changePaymentType', 'QRCODE')">
            <img src="@/assets/img/bit-coin-line.svg" class="walletconnect__wallet_icon" alt="" />
            <div class="walletconnect__wallet_name ml-2">{{ $t('payment.scanpay') }}</div>
          </button>
        </div>
        <small class="error mt-2" v-if="customErrorMessage">
          {{
      customErrorMessage
    }}
        </small>
        <div class="info-container">
          <div class="d-flex">
            <img class="mr-2" src="@/assets/img/loader.svg" alt="" />
            <div class="info-container__title">Did you know section?</div>
          </div>

          <div class="info-container__subtitle mt-2">Lorem idivsum dolor</div>
        </div>
      </div>
      <div v-else-if="isConnected">
        <div class="walletconnect__connected">
          <div class="walletconnect__connected_title text-center">
            Wallet connected
          </div>
          <div class="walletconnect__connected_container">
            <img class="walletconnect__wallet_icon_connected" :src="getIcon(activeConnector.id)" alt="" />
            <div class="walletconnect__wallet_title_connected">
              {{ activeConnector.name }}
            </div>
          </div>
          <div class="walletconnect__wallet_account">
            Account: {{ getWrappedText(address) }}
          </div>
        </div>
        <div class="walletconnect__amount_container" @click="!qrDataProps ? (showDropdown = !showDropdown) : null">
          <div class="d-flex flex-row align-items-center">
            <img v-if="selectedToken" :src="selectedToken?.logo" alt="" class="walletconnect__currency_icon" />
            <div class="walletconnct__currency_text">
              {{ selectedToken?.symbol }}
            </div>
          </div>
          <div class="d-flex flex-row align-items-center">
            <div class="d-flex flex-column mr-2">
              <div class="walletconnect__balance_crypto">
                {{ NumberFormat(DecimalNumber(selectedToken?.formatted || 0).toFixed(6)) }} {{ selectedToken?.symbol }}
              </div>
              <div class="walletconnect__balance_usd">
                {{ NumberFormat(
      DecimalNumber(selectedToken?.formatted || 0)
        .mul(selectedToken?.currentRate || 0).toFixed(2),
      2) }} USD
              </div>
            </div>
            <img v-if="!qrDataProps" alt="" src="@/assets/img/down-arrow1.svg" class="walletconnect__currency_icon" />
          </div>
        </div>

        <b-collapse class="cs-dd__options" role="tabpanel" id="my-accordion" v-model:open="showDropdown">
          <div v-for="(token, i) in tokens" v-bind:key="i" class="walletconnect__select"
            @click="handleSelectToken(token)">
            <div class="d-flex flex-row align-items-center">
              <img alt="" :src="token.logo || require('@/assets/img/info-2.svg')"
                class="walletconnect__select_currency_icon" />
              <div class="w-100">{{ token.symbol }}</div>
            </div>
            <div class="walletconnect__select_balance" v-if="token.logo">
              {{ parseFloat(token.formatted).toFixed(5) }} {{ token.symbol }}
            </div>
            <div class="walletconnect__select_balance disabled" v-else>
              <i>Not supported</i>
            </div>
          </div>
        </b-collapse>
        <div class="walletconnect__balance_text mb-2 d-flex flex-row justify-content-between" v-if="selectedToken">
          <div>Conversion rate:</div>
          <div>1 {{ payableData?.payable_currency }} = {{
      Number(DecimalNumber(payableData?.conversion_rate_per_unit).toFixed(2)) }} {{ payableData?.order_currency }}
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <div class="walletconnect__you_pay">You Pay</div>
          <div>
            <div class="walletconnect__amount_field" v-if="!qrDataProps">
              {{ payableData?.payable_amount }} {{ payableData?.payable_currency }}
            </div>
            <div v-else-if="paymentStatus?.recievedAmount" class="walletconnect__amount_field">
              {{
      DecimalNumber(payableData?.payable_amount).minus(
        paymentStatus?.recievedAmount || 0
      )
    }} {{ payableData?.payable_currency }}
            </div>
          </div>
        </div>

        <small class="error mt-2" v-if="error || customErrorMessage">
          {{
      error
        ? error?.message.split(":").length > 1
          ? error?.message.split(":")[
          error?.message.split(":").length - 1
          ]
          : error.message
        : customErrorMessage
          ? customErrorMessage.split(":").length > 1
            ? customErrorMessage.split(":")[
            customErrorMessage.split(":").length - 1
            ]
            : customErrorMessage
          : ""
    }}
        </small>
        <CustomButton className="walletconnect__pay_button" :disabled="!qrData || !selectedToken"
          @handle-click="handlePay()" :name="`Pay`" />

        <CustomButton v-if="activeConnector" className="walletconnect__disconnect_button" :disabled="false"
          @handle-click="handleDisconnectModal(true)" :name="`Change payment method`" />
      </div>
    </div>
    <div v-else>
      <div v-if="!qrDataProps" class="walletconnect__amount_field text-center">
        {{ payableData?.payable_amount }} {{ payableData?.payable_currency }}
      </div>
      <div v-else class="walletconnect__amount_field text-center">
        {{
      DecimalNumber(payableData?.payable_amount).minus(
        paymentStatus?.recievedAmount || 0
      )
    }}
      </div>
      <div class="walletconnect__connected_container margin-0">
        <img class="walletconnect__wallet_icon_connected" :src="getIcon(activeConnector.id)" alt="" />
        <div class="walletconnect__wallet_title_connected">
          {{ activeConnector.name }}
        </div>
      </div>
      <vertical-progress-bar :steps="paymentSteps" :active="transactionStatus"></vertical-progress-bar>
    </div>
    <PopupModal :title="`Are you sure?`" id="disconnect-wallet" :showModal="disconnectModal"
      :description="`Your wallet will be disconnected`" :cancel="'Stay'" :icon="getIcon(activeConnector?.id)"
      :dismiss="'Disconnect'" @cancelClicked="handleCancel" @dismissClicked="handleDisconnect()" />
  </div>
  <!-- EXTERNAL COMPONENT TO BE MENTIONED BELOW -->
</template>

<script>
import alchemy from "@/utils/alchemy.config";
import CustomButton from "@/views/customButton.vue";
import {
  useConnect,
  useAccount,
  useDisconnect,
  useNetwork,
  useSwitchNetwork,
} from "use-wagmi";
import {
  fetchBalance,
  prepareSendTransaction,
  sendTransaction,
} from "use-wagmi/actions";
import { mapGetters } from "vuex";
import { transactionSourceEnum } from "@/store/modules/user/enums";
import {
  CURRENCY_COMPARE,
  GET_EXTERNAL_STATUS,
  GET_PAYABLE_AMOUNT,
  PURCHASE_EXTERNAL,
  SET_RESULT_PAGE_DATA,
  SET_TAB,
  USER_TRACK_EVENTS,
  WALLET_PAYMENT_CONFIRMED,
} from "@/store/modules/user/consts";
import { parseEther } from "viem";
import VerticalProgressBar from "./VerticalProgressBar.vue";
import { paymentSteps } from "@/utils/config";
import PopupModal from "./PopupModal.vue";
import { PARTIAL_PAYMENT_TRIGGER } from "@/utils/event.constants";
import { walletIds, iframeClient } from '../utils/config';
import { isMobileAgent } from '../utils/helper';

export default {
  name: "WalletConnect",
  components: {
    CustomButton,
    VerticalProgressBar,
    PopupModal,
  },
  props: {
    cartData: Object,
    qrDataProps: Object,
    onConnectionChange: Function,
    changePaymentType: Function,
  },
  setup() {
    const { connectors, error, pendingConnector, connectAsync: connect } = useConnect();

    const { disconnect } = useDisconnect();
    const {
      address,
      isConnected,
      isConnecting,
      connector: activeConnector,
    } = useAccount();
    const { chain } = useNetwork();
    const {
      chains,
      error: changeNetworkError,
      isLoading,
      pendingChainId,
      switchNetwork,
    } = useSwitchNetwork();
    return {
      error,
      isConnecting,
      pendingConnector,
      disconnect,
      activeConnector,
      connectors,
      isConnected,
      connect,
      chain,
      chains,
      changeNetworkError,
      isLoading,
      pendingChainId,
      switchNetwork,
      address,
      paymentSteps,
    };
  },
  data() {
    return {
      tokens: [],
      selectedToken: null,
      payableData: null,
      qrData: {},
      inProgressWallet: null,
      customErrorMessage: "",
      hash: "",
      convertedCart: {},
      transactionStatus: 0,
      paymentStatus: null,
      count: 0,
      interval: null,
      showDropdown: false,
      walletConnect: "walletConnect",
      disconnectModal: false,
      resultData2: {
        // eslint-disable-next-line
        icon: require("@/assets/img/success.svg"),
        title: this.$t("result.success"),
        description: this.$t("result.success-text"),
      },
      loaderTitle: "",
      loaderIcon: "",
      loaderDescription: "",
      loaderButtonText: "Cancel",
      disableDropDown: false,
    };
  },
  mounted() {
    this.$nextTick(async () => {
      this.$refs.loader.start();
      this.$emit("setInprocess", false);
      if (this.qrDataProps) {
        this.qrData = this.qrDataProps;
      }
      if (this.isConnected) {
        this.loaderIcon = this.getIcon(this.activeConnector.id);
        this.loaderTitle = "Fetching data...";
        this.loaderDescription =
          "Please wait while we search for your existing connections.";
        this.loaderButtonText = "Cancel";
        this.loaderButtonText = null;
        await this.getBalance();
        await this.getPayableData();
        this.$emit("onConnectionChange", this.isConnected);
        if (!this.qrDataProps) this.$refs?.loader?.hide();
      } else {
        this.$refs?.loader?.hide();
      }
    });
  },
  unmounted() {
    this.clearThisInterval();
  },
  watch: {
    isConnecting: {
      handler(val) {
        if (val) {
          this.loaderTitle = "Connecting...";
          this.loaderDescription =
            "Please check your wallet and approve the connection.";
          this.loaderButtonText = 'Cancel';
          this.loaderIcon = this.getIcon(this.inProgressWallet.id);
          this.$emit("setInprocess", true);
          this.$refs.loader?.start();
        } else {
          this.$emit("setInprocess", false);
          this.$refs.loader?.hide();
        }
      },
    },
    isConnected: {
      async handler(val) {
        if (val) {
          this.$refs.loader.start();
          await this.getBalance();
          await this.getPayableData();
          this.$refs?.loader?.hide();
          this.$emit("setInprocess", false);
        }
        this.$emit("setInprocess", false);
        this.customErrorMessage = "";
        this.$emit("onConnectionChange", val);
      },
    },
    selectedToken: {
      async handler(val) {
        if (val) {
          this.getPayableData();
          if (!this.qrDataProps) {
            this.qrData = await this.callExternalPurchase();
          } else {
            this.callExternalStatusCheck();
          }
        }
      },
      deep: true,
    },
    qrData: {
      async handler(qr) {
        if (qr?.walletPayment) {
          if (this.hash) {
            this.transactionStatus = 1;
            this.callExternalStatusCheck();
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    filteredConnectors() {
      return (
        this.connectors?.value?.filter(
          (c) => c.ready && c.id !== this.activeConnector.value?.id
        ) || []
      );
    },
    ...mapGetters({
      currencies: "user/currencies",
      settings: "user/settings",
      displayCurrency: "user/displayCurrency",
      cart: "user/cart",
      userInfo: "user/userInfo",
      paymentCompleted: "auth/paymentCompleted",
    }),
    amount() {
      if (this.cart && this.selectedToken) {
        return this.cart.amount * this.selectedToken.currentRate;
      }
      return 0;
    },
  },
  methods: {
    handleNetworkChange(event) {
      this.switchNetwork(event.target.value);

    },
    handleSelectToken(val) {
      if (val.currentRate) {
        this.selectedToken = val;
        this.showDropdown = false;
      }
    },
    getIcon(val) {
      try {
        return require(`@/assets/img/wallets/${val}.svg`);
      } catch (err) {
        return "";
      }
    },
    async getBalance() {
      const bal = await alchemy.core.getTokenBalances(this.address);
      const mainBalance = await fetchBalance({
        address: this.address,
      });
      const promise = bal.tokenBalances.map(
        async (val) =>
          await fetchBalance({
            address: this.address,
            token: val.contractAddress,
            formatUnits: "ether",
          })
      );
      let data = await Promise.all(promise);
      data.push(mainBalance);
      const tokens = data.filter((val) => {
        const currency = this.currencies.find(
          (v) => v.id.toUpperCase() === val.symbol.toUpperCase()
        );
        if (currency) {
          val.logo = currency.logo;
          val.currentRate = currency.currentRate;
          val.chainNetwork = currency["chains.network"];
          return true;
        } else {
          val.logo = null;
          val.currentRate = 0;
          val.chainNetwork = "";
          return false;
        }
      });
      // sort according to balance higher balance should be at the top
      this.tokens = tokens?.sort((a, b) => {
        if ((this.DecimalNumber(a?.formatted || 0)
          .mul(a?.currentRate || 0)) < (this.DecimalNumber(b?.formatted || 0).mul(b?.currentRate || 0))) {
          return 1;
        } else {
          return -1;
        }
      })
      if (this.qrDataProps) {
        const find = this.tokens.find(
          (c) => c.symbol === this.qrDataProps.currency
        );
        if (find) {
          this.selectedToken = find;
        }
      } else {
        this.selectedToken = this.tokens[0];
      }
    },
    getWrappedText(text) {
      if (text.length > 16) {
        const length = text.length / 2;
        const truncated = text.substring(0, length);
        const last5Chars = text.substring(text.length - 10);
        return `${truncated}...${last5Chars}`;
      }
      return text;
    },
    async handlePay() {
      // create transaction
      this.loaderTitle = "Waiting for Payment...";
      this.loaderDescription = "Please check your wallet.";
      this.loaderButtonText = "Cancel Transaction";
      this.$emit("setInprocess", true);
      try {
        this.$refs.loader.start();
        this.customErrorMessage = "";
        if (!this.qrData) {
          this.customErrorMessage = "cannot proceed with payment";
          return;
        }
        let amount = this.qrData.amount;
        if (this.qrDataProps) {
          if (!this.paymentStatus && !this.paymentStatus.recievedAmount) {
            await this.callExternalStatusCheck();
          }
          amount = this.DecimalNumber(this?.qrData?.amount)
            .minus(this.paymentStatus?.recievedAmount || 0)
            .toString();
        }
        const request = await prepareSendTransaction({
          to: this.qrData.meta.receiverAddress,
          value: parseEther(amount),
        });

        const { hash } = await sendTransaction(request);
        console.log({
          clientId: this.convertedCart.merchant_id,
          id: this.qrData.id,
          offerId: this.convertedCart.order,
          hash,
          walletname: this.activeConnector.name
        })
        const res = await this.$store.dispatch(
          `user/${WALLET_PAYMENT_CONFIRMED}`,
          {
            encrypted: this.Encrypt({
              clientId: this.convertedCart.merchant_id,
              id: this.qrData.id,
              offerId: this.convertedCart.order,
              hash,
              walletname: this.activeConnector.name
            }),
            source: transactionSourceEnum.IFRAME_WALLET_CONNECT,
          }
        );
        this.hash = hash;
        this.transactionStatus = 1;
        this.callExternalStatusCheck();
        this.$refs?.loader?.hide();
      } catch (err) {
        this.customErrorMessage = err.details;
        this.$emit("setInprocess", false);
        this.$refs?.loader?.hide();
      }
    },

    async getPayableData() {
      if (!this.selectedToken.symbol || !this.cart.uuid) {
        return;
      }
      try {
        const resp = await this.$store.dispatch(`user/${GET_PAYABLE_AMOUNT}`, {
          cc: this.selectedToken.symbol,
          invoice: this.cart.uuid,
        });

        this.payableData = resp;
        return;
      } catch (err) {
        // todo
      }
    },
    async callExternalPurchase() {
      try {
        this.qrData = {};
        let conversionRate = 1;
        this.customErrorMessage = "";
        const usdEquivalentRate = 1;
        this.convertedCart = {};
        if (this.settings?.displayCurrency !== undefined && this.cart) {
          // eslint-disable-next-line no-param-reassign, vue/no-mutating-props
          this.cart.currency =
            this.cart?.currency !== undefined ? this.cart?.currency : "USD";
          // Perform conversion if the currency are different
          if (
            this.settings?.displayCurrency.toUpperCase() !==
            this.cart?.currency.toUpperCase()
          ) {
            conversionRate = await this.getCurrConverRate(
              this.cart?.currency,
              this.settings?.displayCurrency
            );
          }
          this.convertedCart = this.cart;
          this.convertedCart.usdEquivalentRate = usdEquivalentRate;
          this.convertedCart.conversionRate = conversionRate;
          this.convertedCart.displayCurrency = this.settings?.isUserConfigured
            ? this.settings?.displayCurrency.toUpperCase()
            : this.cart?.currency.toUpperCase();
        }
        if (
          !this.convertedCart ||
          !this.convertedCart.cart ||
          !this.convertedCart.amount
        ) {
          throw new Error("cart data invalid!");
        }
        const res = await this.$store.dispatch(`user/${PURCHASE_EXTERNAL}`, {
          encrypted: this.Encrypt({
            clientId: this.convertedCart.merchant_id,
            amount: this.convertedCart.amount,
            currency: this.selectedToken.symbol.toUpperCase(),
            chainNetwork: this.selectedToken.chainNetwork,
            cart: this.convertedCart.cart,
            shippingAddress: this.cart.shippingAddress
              ? this.cart.shippingAddress
              : null,
            merchantStoreCurrency: this.cart.currency,
            offerId: this.convertedCart.order,
            confirmation: this.convertedCart.encrypted || "",
            hostedPageId: this.convertedCart.uuid || "",
          }),
          source: transactionSourceEnum.IFRAME_WALLET_CONNECT,
        });
        if (res.status === "ok") {
          if (
            Number(this.selectedToken.formatted) <= Number(res.response.amount)
          ) {
            this.customErrorMessage = "Low Wallet Balance";
          }
          return res.response;
        } else if (res.status === "error") {
          this.customErrorMessage = res.response;
          return null;
        }
      } catch (e) {
        // todo
        this.customErrorMessage = e?.message;
        return null;
      }
    },
    async getCurrConverRate(from, to) {
      const res = await this.$store.dispatch(`user/${CURRENCY_COMPARE}`, {
        to: to.toUpperCase(),
        from: from.toUpperCase(),
        source: transactionSourceEnum.WALLET,
      });
      if (res.status === "ok") {
        return res[to.toUpperCase()];
      }
      return 1;
    },
    async callExternalStatusCheck() {
      this.$emit("setInprocess", true);
      if (this.count === 0) this.$refs?.loader?.start();
      this.interval = setInterval(async () => {
        this.count += 1;
        try {
          const payload = {
            txId: this.qrData.id,
            status: 1,
            source: transactionSourceEnum.IFRAME_WALLET_CONNECT,
          };

          if (this.count === 1 && this.qrDataProps) this.$refs?.loader?.start();
          const resp = await this.$store.dispatch(
            `user/${GET_EXTERNAL_STATUS}`,
            payload
          );
          this.validateResponse(resp?.data?.result?.responseObj);
          return;
        } catch (err) {
          this.clearThisInterval();
          this.$emit("setInprocess", false);
        }
      }, 5000);
    },
    clearThisInterval() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    async validateResponse(data) {
      this.paymentStatus = data;
      switch (data?.txStatus) {
        case "pending": {
          break;
        }
        case "partial": {
          this.$emit("setInprocess", true);
          this.$refs?.loader?.hide();
          window.EventBus.emit(PARTIAL_PAYMENT_TRIGGER)
          break;
        }
        case "completed": {
          this.clearThisInterval();
          await this.$store.commit("auth/changePaymentCompleted");
          this.paymentStatus = data;
          this.transactionStatus = 2;
          setTimeout(() => {
            this.complete(this.paymentStatus);
          }, 5000);
          break;
        }
        default:
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "IncompletePayment",
              activity: "Payment using WalletConnet fails or shopper cancels",
              meta: {
                status: "Failed"
              },
            },
          });
          break;
      }
    },
    async complete(paymentStatus) {
      this.customErrorMessage = "";
      if (!this.error && !this.customErrorMessage) {
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: "Wallet Connect",
            activity: "Wallet Connect Payment Success",
            meta: {
              name: this.selectedToken.symbol,
            },
          },
        });
        await this.$store.commit("user/clearCart");
        this.notifyParentWindow({
          type: "rocketfuel_result_ok",
          response: {
            paymentMode: "Wallet",
            status: paymentStatus.txStatus,
            recievedAmount: paymentStatus.recievedAmount,
            currency: paymentStatus.currency,
          },
          paymentCompleted: this.paymentCompleted,
        });
        this.$store.dispatch(`user/${SET_TAB}`, "");
        if (this.userInfo && this.userInfo.ssoStatus) {
          this.$router.push({ name: "Thank" });
        } else {
          this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, this.resultData2);
          this.$router.push({
            name: "Result",
          });
        }
      }
    },
    handleCancel() {
      this.handleDisconnectModal(false);
    },
    handleDisconnect() {
      this.$refs?.loader?.start();
      this.disconnect(this.activeConnector);
      this.tokens = [];
      this.selectedToken = null;
      this.payableData = null;
      this.qrData = {};
      this.inProgressWallet = null;
      this.customErrorMessage = "";
      this.handleDisconnectModal(false);
      this.$refs?.loader?.hide();
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: 'DisconnectWalletConnet',
          activity: 'Shopper disconnects a connected wallet',
          meta: {
            walletConnect: this.activeConnector.id,

          },
        },
      });
    },
    cancelPay() {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "IncompletePayment",
          activity: "Payment using WalletConnet fails or shopper cancels",
          meta: {
            status: "Cancelled"
          },
        },
      });
    },
    handleDisconnectModal(val) {
      this.disconnectModal = val;
    },
    async handleConnect(connector) {
      try {
        this.inProgressWallet = connector;
        this.loaderButtonText = "Cancel Transaction";
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: 'StartWalletConnect',
            activity: 'Shopper clicked on a wallet connect option',
            meta: {
              walletConnect: connector.id,
              client: isMobileAgent() ? iframeClient.mobile : iframeClient.desktop
            },
          },
        });
        // if (connector.id === walletIds.coinbaseWallet) {
        //   if (!window?.coinbaseWalletExtension || window?.coinbaseWalletExtension === undefined) {
        //     this.customErrorMessage = 'Coinbase Wallet extension not installed';
        //     return;
        //   }
        // }
        if (connector.id === walletIds.metamaskWallet) {
          if (!window.ethereum || window.ethereum === undefined) {
            this.customErrorMessage = 'Metamask Wallet extension is not installed';
            return;
          }
        }


        const response = await this.connect({ connector, chainId: 1 });

        if (response) {
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: 'SuccessWalletConnect',
              activity: 'Shopper successfully connects wallet',
              meta: {
                walletConnect: connector.id,
                client: isMobileAgent() ? iframeClient.mobile : iframeClient.desktop
              },
            },
          });
        }
      } catch (err) {
        this.customErrorMessage = err.shortMessage;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.walletconnect {
  background: #fff;

  &__balance_crypto {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }

  &__balance_usd {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }

  &__you_pay {
    //styleName: Text/Regular/sm: 14px;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: right;
    color: #04193999;

  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: left;
    padding-top: 5px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }

  &__buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 16px 24px;
    box-shadow: 0px 2px 8px 0px #5757f51a;
    align-items: center;
    cursor: pointer;
  }

  &__wallet_icon {
    width: 40px;
    height: 40px;
  }

  &__wallet_icon_connected {
    width: 63px;
    height: 63px;
  }

  &__wallet_name {
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: left;
  }

  &__wallet_name_sub {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }

  &__connected_title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
  }

  &__wallet_title_connected {
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    margin-top: 20px;
  }

  &__connected_container {
    padding: 20px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  &__wallet_account {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    color: #333;
  }

  &__pay_button {
    // On click
    // Navigate to: "Wallet";
    // Animate: Smart animate;
    animation-timing-function: ease-out;
    animation-duration: 300ms;
    width: 100%;
    border-radius: 4px;
    border: 2px;
    background: linear-gradient(0deg, #5757f5, #5757f5),
      linear-gradient(0deg, rgba(87, 87, 245, 0.6), rgba(87, 87, 245, 0.6));
    border: 2px solid rgba(87, 87, 245, 0.6);
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: center;
  }

  &__disconnect_button {
    background: transparent;
    color: rgba(87, 87, 245, 0.6);
    border: none;
    outline: none;
    width: 100%;
    margin-top: 10px;

    &:hover {
      background: transparent;
      outline: 2px solid rgba(87, 87, 245, 0.6);
      color: rgba(87, 87, 245, 0.6);
    }

    &:active {
      background: transparent;
      outline: 2px solid rgba(87, 87, 245, 0.6);
      color: rgba(87, 87, 245, 0.6);
    }

    &:focus {
      background: transparent;
      outline: 2px solid rgba(87, 87, 245, 0.6);
      color: rgba(87, 87, 245, 0.6);
    }

    &:not(:disabled) {
      background: transparent;
      outline: 2px solid rgba(87, 87, 245, 0.6);
      color: rgba(87, 87, 245, 0.6);
    }
  }

  &__amount_container {
    border: 2px solid rgba(87, 87, 245, 1);
    width: 100%;
    padding: 8px 10px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
  }

  &__amount_field {
    //styleName: Text/Medium/2xl: 24px;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0em;
    text-align: left;
  }

  &__balance_text {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    color: #04193999;
  }

  &__currency_icon {
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }

  &__select_currency_icon {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }

  &__select {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0em;
    border: 1px solid #ddd;
  }

  &__currency_text {
    padding: 5px;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0em;
  }

  &__select_balance {
    font-size: 12px;
  }

  &__partial_container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
  }
}

.info-container {
  border: 1px solid rgba(87, 87, 245, 1);
  padding: 10px;
  border-radius: 5px;
  margin-top: 15px;

  &__title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
  }

  &__subtitle {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
}

.disabled {
  color: #ddd !important;
  cursor: not-allowed;
}

.margin-0 {
  margin: 0 !important;
}

.cs-dd__options {
  max-height: 200px !important;
  overflow-y: auto;
}
</style>
